import React, { useState, useEffect } from 'react';
import i18n from 'i18n-react';

import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';

import { productLinks, storageKeys } from 'settings';
import { StorageHandler } from 'C4';

const buttons = {
  ios: {
    href: productLinks.ios,
    src: apple,
    alt: 'App Store',
  },
  android: {
    href: productLinks.android,
    src: google,
    alt: 'Google Play',
  },
};

const getBenefits = () => {
  const {
    texts: { onMobile },
  } = i18n;

  if (!onMobile || !onMobile.benefits) return [];
  const {
    benefits: { header, ...benefits },
  } = onMobile;

  return Object.keys(benefits);
};

const MobileWarning = () => {
  const benefits = getBenefits();

  return (
    <div className="container__mobileButtons">
      <section>{i18n.translate('onMobile.body')}</section>
      <h5>{i18n.translate('onMobile.benefits.header')}</h5>
      <ul>
        {benefits.map((i) => (
          <li key={i}>{i18n.translate(`onMobile.benefits.${i}`)}</li>
        ))}
      </ul>
      <div className="buttons">
        {Object.values(buttons).map(({ href, src, alt }) => (
          <a href={href} key={alt}>
            <img src={src} alt={alt} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default MobileWarning;
